// Imports
import { Box } from "@mui/system";
import { useEffect } from "react";
import styles from "./homepage.module.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setNavSelection } from "../../features/navSelection";
import { DashboardIconImageLinks, Urls } from "../../config/Constants";

export enum BookingStateFilters {
  ALL = "All",
  TODAY_PICKUPS = "Today's Pickups",
  TODAY_PENDING_PICKUPS = "Today's Pending Pickups",
  TODAY_DROPS = "Today's Drops",
  TODAY_PENDING_DROPS = "Today's Pending Drops",
  TOMORROW_PICKUPS = "Tomorrow's Pickups",
  TOMORROW_DROPS = "Tomorrow's Drops",
  ONGOING_TIME = "Ongoing (by Time)",
  ONGOING_STATUS = "Ongoing (by Status)",
  UPCOMING_TIME = "Upcoming (by Time)",
  UPCOMING_STATUS = "Upcoming (by Status)",
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
}
export enum SearchFilters {
  BOOKING_ID = "Booking ID",
  PHONE_NUMBER = "Phone",
  RC_NUMBER = "Bike Number",
}

export function Homepage(props: { window?: () => Window; drawerWidth: number }) {

  // Global state
  const dispatch = useDispatch();

  // Set nav state
  useEffect(() => {
    dispatch(setNavSelection(0));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box
      sx={{
        mt: { xs: 10, md: 0 },
        ml: { xs: 0, md: `${props.drawerWidth}px` },
        width: { xs: "100%", md: `calc(100% - ${props.drawerWidth}px)` },
        height: "100%",
      }}
    >
      <Box className={`gbk-tabcontent allow-scroll`}>
        {/* Header */}

        <div className={styles.root}>

          <div className={styles.grid}>
            {[{
              link: '/bookings',
              iconLink: DashboardIconImageLinks.BOOKINGS,
              label: 'Bookings'
            }, {
              link: '/bikes',
              iconLink: DashboardIconImageLinks.VEHICLES,
              label: 'Vehicles'
            }, {
              link: '/accessories',
              iconLink: DashboardIconImageLinks.ACCESSORIES,
              label: 'Accessories'
            }, {
              link: '/reviews',
              iconLink: DashboardIconImageLinks.REVIEWS,
              label: 'Reviews'
            }, {
              link: '/ledger',
              iconLink: DashboardIconImageLinks.LEDGER,
              label: 'Payments'
            }, {
              link: '/profile',
              iconLink: DashboardIconImageLinks.PROFILE,
              label: 'Profile'
            }, {
              link: '/dashboard',
              iconLink: DashboardIconImageLinks.DASHBOARD,
              label: 'Analytics'
            }, {
              link: '/blocks',
              iconLink: DashboardIconImageLinks.BLOCK_VEHICLES,
              label: <span>Block<br />Vehicles</span>
              // }, {
              //   link: '/',
              //   iconLink: DashboardIconImageLinks.KYC,
              //   label: 'KYC'
            }, {
              link: '/offers',
              iconLink: DashboardIconImageLinks.OFFERS,
              label: 'Offers'
            }].map((e, i) => (
              <Link key={i} to={e.link}>
                <div className={styles.gridCard}>
                  <img alt="" src={`${Urls.STATIC_SITE}/uploads/admin/site/${e.iconLink}`} />
                  <br />
                  <span>{e.label}</span>
                </div>
              </Link>
            ))}
          </div>
          <div className={styles.help}>
            <div className={styles.image}><img src={`${Urls.STATIC_SITE}/uploads/admin/site/${DashboardIconImageLinks.HELP}`} alt="help icon" /></div>
            <div className={styles.text}>
              <span>Have a doubt or need some help?</span> <br />
              <span className={styles.callText}>Call Support</span><br />
              <span className={styles.phone}><a href="tel:+918448444897"><u>+91-8448444897</u></a></span>
              <span className={styles.callText}><b>Timings: 7AM to 11PM</b></span><br />
            </div>
          </div>
        </div>
      </Box>
    </Box>


  );
}
